import { useCallback, useState } from 'react'
import { View } from 'react-native'
import { Menu } from 'react-native-popup-menu'
import { useRecentStoresContext } from 'stores/context'
import { useUser } from 'users/queries/detail'
import { RatingMenu } from '../menu'
import { useAddMultipleShiftsRating } from '../queries/add'
import { useRatingsList } from '../queries/list'
import { CrewRating, CrewRatingMap } from '../queries/shared/types'
import { MultipleRatingsView } from './view'

interface MultipleRatingsScreenProps {
  menuRef: React.MutableRefObject<Menu | null | undefined>
  onCloseRatingMenu(): void
}

export function MultipleRatingsScreen({
  menuRef,
  onCloseRatingMenu,
}: MultipleRatingsScreenProps) {
  const { data: rater } = useUser()
  const { activeStoreId } = useRecentStoresContext()

  const ratingsListQuery = useRatingsList(activeStoreId)
  const ratingsMutation = useAddMultipleShiftsRating(activeStoreId)

  const [error, setError] = useState<any>(undefined)
  const [crewRatings, setCrewRatings] = useState<CrewRatingMap>({})

  const onPressCloseButton = useCallback(async () => {
    await menuRef.current?.close()
  }, [menuRef])

  const onChangeCrewRating = useCallback(
    (crewRating: CrewRating) => {
      const updatedCrewRatings = { ...crewRatings }
      updatedCrewRatings[crewRating.shiftId] = crewRating
      setCrewRatings(updatedCrewRatings)
    },
    [crewRatings]
  )

  const onSubmit = useCallback(async () => {
    try {
      await ratingsMutation.mutateAsync(Object.values(crewRatings))
      await menuRef.current?.close()
    } catch (err: any) {
      setError(err)
    }
  }, [crewRatings, menuRef, ratingsMutation])

  return (
    <View>
      <RatingMenu menuRef={menuRef} onCloseRatingMenu={onCloseRatingMenu}>
        <MultipleRatingsView
          shifts={ratingsListQuery.data}
          onPressCloseButton={onPressCloseButton}
          onChangeCrewRating={onChangeCrewRating}
          rater={rater}
          onSubmit={onSubmit}
          crewRatings={crewRatings}
          error={error}
        />
      </RatingMenu>
    </View>
  )
}
